import * as $ from "jquery";

export function activateCookiebanner() {
    let resizeTimer: number;

    function adjustCookieBannerHeight() {
        const $cookieBanner = $('#ww_bzga_matomo_cookiebanner');
        const $description = $('#cookiebanner_description_moreinfo');
        
        if ($cookieBanner.length && $description.length) {
            const windowHeight = $(window).height();
            const otherContentHeight = $cookieBanner.find('*').not('#cookiebanner_description_moreinfo').outerHeight(true);
            const availableHeight = windowHeight - otherContentHeight;
            
            $description.height(availableHeight);
        }
    }

    $('#cookiebanner_button_moreinfo').on('click', function() {
        $('body').toggleClass('cookie-banner-open');
    });

    $(document).ready(function() {
        adjustCookieBannerHeight();
    });

    $(window).on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function() {
            adjustCookieBannerHeight();
        }, 250);
    });
}